import { render, staticRenderFns } from "./roomGame.vue?vue&type=template&id=2af8f504&lang=pug&"
import script from "./roomGame.vue?vue&type=script&lang=js&"
export * from "./roomGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports